//bullsh*t, we just need to list perms once as keys of an object
const permissions = {
  canEditAccountingData: 0,
  canEditConstructionData: 0,
  canEditSalesData: 0,
  canManageManagers: 0,
  canManagePrograms: 0,
  canManageSciArticles: 0,
  canManageUsers: 0,
  canValidateOptions: 0,
  canValidateBuyers: 0,
  canValidateReservations: 0,
  canActForSellers: 0,
  canEnableDocusign: 0,
  canSendNotifications: 0,
  canAddOptions: 0,
  canCancelOptions: 0,
  canCancelPurchases: 0,
  canRequestSigning: 0,
  canAddBuyers: 0,
  canDeleteBuyers: 0,
  canEditBuyers: 0,
  canAddPurchases: 0,
  canExportSearchResults: 0,
  canExportSellers: 0,
  canExportProgram: 0,
  canEnableAr24: 0,
  canManageFundraisingStepsCertificates: 0,
  canEditFiscalDevices: 0,
};

export type Permission = keyof typeof permissions;

type PermissionsType = {
  [K in Permission]: K;
};

//@ts-ignore little hack
export const Permissions: PermissionsType = Object.fromEntries(Object.keys(permissions).map((p) => [p, p]));
